import { upsellPageDataDbWriteValidator } from "@redotech/redo-model/upsell-page/upsell-page-db-validator";
import * as z from "zod";

export const updateUpsellPage = {
  name: "updateUpsellPage" as const,
  input: z.object({
    teamId: z.string(),
    upsellPageId: z.string(),
    upsellPageData: upsellPageDataDbWriteValidator,
  }),
  output: z.null(),
};
